import { FETCH_ALL_REPROCESSING, DELETE_REPROCESSING } from "../actions/types";
import _ from 'lodash';
const INITIAL_STATE = {data: {},paginate:{}}

export default (state=INITIAL_STATE, action) => {
    switch (action.type) {
        case FETCH_ALL_REPROCESSING:
            const paginate = _.omit(action.payload, 'data');
            return {...state, data:_.mapKeys(action.payload.data, 'id'), paginate}
        case DELETE_REPROCESSING:
            return {...state, data:_.omit(state.data, action.payload)};
        default:
            return state;
    }
}